export const DashboardImporticon = ({
  primaryFontColor = 'var(--primary-bg-color)',
  color = 'var(--primary-background-text-color',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g
        id="Group_41551"
        data-name="Group 41551"
        transform="translate(-202 -164)"
      >
        <g
          id="Group_41476"
          data-name="Group 41476"
          transform="translate(-1292 -4)"
        >
          <circle
            id="Ellipse_1248"
            data-name="Ellipse 1248"
            cx="24"
            cy="24"
            r="24"
            transform="translate(1494 168)"
            fill={primaryFontColor}
          />
        </g>
        <g
          id="import_1_"
          data-name="import (1)"
          transform="translate(215.959 172.829)"
        >
          <path
            id="Path_63862"
            data-name="Path 63862"
            d="M16.342,16.464H13.008v1.843h3.334c.992,0,1.761.472,1.761.878v8.173c0,.406-.769.878-1.761.878H3.739c-.992,0-1.761-.472-1.761-.878V19.186c0-.406.769-.878,1.761-.878H7.073V16.465H3.739c-2.1,0-3.739,1.2-3.739,2.721v8.172c0,1.526,1.642,2.721,3.739,2.721h12.6c2.1,0,3.739-1.2,3.739-2.721V19.186C20.082,17.659,18.439,16.464,16.342,16.464Z"
            transform="translate(20.082 35.586) rotate(180)"
            fill={color}
          />
          <path
            id="Path_63863"
            data-name="Path 63863"
            d="M6.91,9.525a.986.986,0,0,0-.7.29L4.972,11.054V.989a.989.989,0,0,0-1.978,0V11.12L1.689,9.815a.989.989,0,0,0-1.4,1.4l2.953,2.953a.985.985,0,0,0,.7.289h.015a.984.984,0,0,0,.7-.289L7.61,11.214a.989.989,0,0,0-.7-1.688Z"
            transform="translate(13.992 24.573) rotate(180)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};
